import React, {
  createContext,
  useState,
  useContext,
  useLayoutEffect,
} from 'react';
import AuthService from '../services/authServise';
import Axios from 'axios';
import { webConfig } from '../config';

export const UserContext = createContext();

const UserContextProvider = (props) => {
  const authServise = new AuthService();
  const [data, setData] = useState(props.initial || null);
  const currentSession = authServise.getCurrentSession();
  const [orgId, setOrgId] = useState();
  const [org, setOrg] = useState();
  const [user, setUser] = useState();

  const apiCall = Axios.create({
    baseURL: webConfig.API_HOST,
    timeout: 30000,
    headers: { Authorization: 'Bearer ' + currentSession.accessToken },
  });

  useLayoutEffect(() => {
    apiCall
      .get(webConfig.USER_API + currentSession.userId)
      .then(async(response) => {
        if (response && response.data && response.data.data) {
          const currentOrg = response.data.data.relationships ? response.data.data.relationships.organization.data : null;
          if (currentOrg) {
            setOrgId(currentOrg.id);
          }
          const currentUser = response.data.data.attributes;
          // extend user object with id
          currentUser.id = currentSession.userId;
          currentUser.devices = [];

          setUser(currentUser);

          setData({
            userdata: response.data,
            isWriter: currentUser.org_admin,
            isWriterError: null,
            user: currentUser,
            currentSession: currentSession,
          });
        }
      });

  }, []);

  useLayoutEffect(() => {
    if (user) {
      apiCall.get('gateways?remote_access=true').then(result => {
        try {
          let userDevices = [];
          result.data.data.forEach(i => {
            let device = {
              id: userDevices.length + 1,
              sn: i.attributes.sn.toString(16).toUpperCase(),
              name:'',
              gatewayId: i.id,
              location: "",
              online: false,
              lastConnection:null,
              statusChecked:false,
              systemInfo:''
            }

            if(i.attributes && i.attributes.attributes && i.attributes.attributes !== "{}") {
              const info = JSON.parse(i.attributes.attributes);
              device.name = info.systemName;
              device.systemInfo = info;
            }

            userDevices.push(device);
          });

          user.devices = userDevices;
        } catch (error) {
          console.log("error:", error);
        }
      })
    }
  }, [user]);

  useLayoutEffect(() => {
    if (orgId) {
      let query = webConfig.ORG_API + orgId;
      apiCall.get(query).then((orgResponse) => {
        if (orgResponse.data && orgResponse.data.data) {
          let organization = orgResponse.data.data.attributes;
          setOrg(organization);
        }
      });
    }
  }, [orgId]);

  return (
    <UserContext.Provider value={{ ...data, org, currentSession, user }}>
      {props.children}
    </UserContext.Provider>
  );
};

const useUserContext = () => useContext(UserContext);

export { useUserContext, UserContextProvider };
